import { SerialisationConfig } from '../../rest/utilities/serialisable'
import { ValidationResult } from './validation-result.interface'

export interface APIResponse<Data = unknown, Meta = unknown> {
  data: Data
  meta: Meta
  error?: {
    message?: string
    errors?: Record<string, string[]>
  }
}

export interface PaginationResponse {
  per_page: number
  current_page: number
  last_page: number
  from: number
  to: number
  total: number
}

export interface PaginationMeta {
  pagination: PaginationResponse
}

export class ApiValidationResult implements ValidationResult {
  messages: string[] | null = null
  fields: Record<string, ValidationResult> = {}

  public static withMessages(messages: string[]): ApiValidationResult {
    const result = new ApiValidationResult()
    result.messages = messages
    return result
  }

  public static generate(
    response: APIResponse,
    config?: SerialisationConfig
  ): ApiValidationResult {
    const result = new ApiValidationResult()
    if (response.error?.message) {
      result.messages = [response.error.message]
    }
    if (response.error?.errors) {
      for (const key in response.error?.errors) {
        if (response.error?.errors[key]) {
          const model = config?.createInstance()
          const field = (model?.getAlias() ?? {})[key] ?? key
          result.fields[field] = new ApiValidationResult()
          result.fields[field].messages = response.error.errors[key]
        }
      }
    }
    return result
  }

  get allMessages(): string[] | null {
    if (Object.keys(this.fields).length > 0) {
      const messages: string[] = []
      for (const key in this.fields) {
        this.fields[key].messages?.forEach((message) => messages.push(message))
      }
      return messages
    }
    return this.messages
  }
}
